(() => {
  const configNode = document.getElementById('rsc-shopping-config');
  if (!configNode || window.rscShoppingReady) return;
  window.rscShoppingReady = true;
  const config = JSON.parse(configNode.textContent);
  const labels = config.labels;
  let currentModal = null;
  let scheduled = false;
  let snapshot = {};
  let returnFocus = null;
  const fieldValues = new Map();
  const controlSelector = '.modal-ui-input-handler-footer-button, .preview-modal-ui-close-button, .preview-modal-ui-close-button-phone';
  const escapeHtml = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  function delivery() {
    const button=document.querySelector('#MainContent .mem_widget_ui button');
    if (!button || document.querySelector('.rsc-delivery-estimate')) return;
    const note=document.createElement('p');note.className='rsc-delivery-estimate';
    note.append(document.createTextNode(labels.delivery+' '));
    const link=document.createElement('a');link.href='/pages/shipping';link.textContent=labels.deliveryDetails;note.append(link);button.after(note);
  }
  function enhanceModal(modal) {
    if(config.productId!==9562463502425) {
      const colors={Black:'#252525',Copper:'#b87333',Gold:'#c6a248',White:'#fff',Silver:'#bcbfc2',Red:'#b6252d',Pink:'#e7a2bd',Blue:'#245aa8',Purple:'#774797',Yellow:'#f2d143',Rose:'#b86d76',Orange:'#e77b27',Stone:'#8b897d',Green:'#37714e'};
      modal.querySelectorAll('.preview-widget-individual-option-wrapper-swatch-images img').forEach(img=>{
        const source=img.getAttribute('src')||'';
        const color=Object.keys(colors).find(c=>new RegExp('(?:[-_/])'+c+'(?:[-_.])','i').test(source));
        if(!color)return;
        const chip=img.parentElement.parentElement;
        if(!chip.dataset.rscColorKey){chip.dataset.rscColorKey='true';chip.dataset.color=color;chip.style.setProperty('--rsc-color',colors[color]);chip.classList.add('rsc-color-chip');chip.parentElement.classList.add('rsc-colors');chip.setAttribute('role','button');chip.setAttribute('aria-label',color);chip.tabIndex=0;chip.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();chip.click();}});}
        chip.setAttribute('aria-pressed',String(chip.classList.contains('selected')));
      });
    }
    modal.querySelectorAll('.design-element-input-wrapper').forEach((wrapper,i)=>{
      const label=wrapper.querySelector('label'),field=wrapper.querySelector('input,select,textarea');
      if(!label||!field)return;
      if(!field.id)field.id='rsc-personalization-field-'+i;
      label.htmlFor=field.id;
      const name=label.textContent.trim();
      if(/^Line [12]$/i.test(name)&&field.getAttribute('placeholder')!==name)field.setAttribute('placeholder',name);
    });
    const steps=[...modal.querySelectorAll('.preview-modal-step-number')];
    const components=[...modal.querySelectorAll('.modal-ui-input-component')];
    if(steps.length) {
      const names=steps.map((step,i)=>i===0?(config.productId===9562463502425?labels.breedOptions:labels.sizeColor):i===steps.length-1?labels.review:config.productId===9562463502425?labels.dogName:components.length===steps.length?[...components[i].querySelectorAll('label')].map(l=>l.textContent.trim()).filter(Boolean).join(' & ')||labels.personalization:labels.personalization);
      let guide=modal.querySelector('.rsc-step-guide');
      if(!guide){guide=document.createElement('p');guide.className='rsc-step-guide';const row=steps[0].closest('.preview-modal-step-wrapper')?.parentElement;row?.after(guide);}
      const text=names.map((n,i)=>(i+1)+'. '+n).join(' → ');
      if(guide.textContent!==text)guide.textContent=text;
      steps.forEach((step,i)=>{step.setAttribute('aria-label',(i+1)+'. '+names[i]);if(step.classList.contains('highlighted')&&step.textContent.trim())step.setAttribute('aria-current','step');else step.removeAttribute('aria-current');});
    }
  }

  function update() {
    scheduled = false;
    delivery();
    const modal = document.querySelector('.preview-modal-ui-container');
    if (modal) enhanceModal(modal);
    if (!modal) { currentModal = null; return; }
    if (modal !== currentModal) {
      currentModal = modal;
      snapshot = {};
      fieldValues.clear();
      returnFocus = document.activeElement;
      modal.setAttribute('role','dialog');
      modal.setAttribute('aria-modal','true');
      modal.setAttribute('aria-label',labels.personalization);
    }
    for (const control of modal.querySelectorAll(controlSelector)) {
      if (!control.dataset.rscKeyboard) {
        control.dataset.rscKeyboard = 'true';
        control.setAttribute('role','button');
        control.addEventListener('keydown', e => {
          if ((e.key === 'Enter' || e.key === ' ') && !control.classList.contains('disabled')) { e.preventDefault(); control.click(); }
        });
      }
      const disabled = control.classList.contains('disabled');
      control.tabIndex = disabled ? -1 : 0;
      control.setAttribute('aria-disabled', String(disabled));
      if (control.matches('.preview-modal-ui-close-button, .preview-modal-ui-close-button-phone')) control.setAttribute('aria-label',labels.close);
    }
    const breed = modal.querySelector('.design-element-images-and-label-container select, #rsc-breed-first');
    if (breed?.value) snapshot.breed = breed.selectedOptions[0]?.textContent;
    const size = modal.querySelector('.preview-widget-individual-option-wrapper.rounded.selected');
    if (size) snapshot.size = parseFloat(size.textContent.trim());
    const color = modal.querySelector('.rsc-color-chip.selected');
    if (color) snapshot.color = color.dataset.color;
    else {
      const source=modal.querySelector('.swatch-image-variant.selected img')?.getAttribute('src') || '';
      const colors=['Black','Copper','Gold','White','Silver','Red','Pink','Blue','Purple','Yellow','Rose','Orange','Stone','Green'];
      const selectedColor=colors.find(name=>new RegExp('(?:[-_/])'+name+'(?:[-_.])','i').test(source));
      if(selectedColor) snapshot.color=selectedColor;
    }
    const price = modal.querySelector('.modal-ui-price-container');
    if (price) snapshot.price = price.textContent.trim();
    for (const input of modal.querySelectorAll('input:not([type="hidden"]), textarea, select[name]')) {
      if (input.name && !['quantity'].includes(input.name.toLowerCase())) fieldValues.set(input.name, input.value);
    }
    const finalButton = [...modal.querySelectorAll('.modal-ui-input-handler-footer-button')].find(e=>e.textContent.trim().toLowerCase()==='add to cart');
    const oldSummary = modal.querySelector('.rsc-review');
    if (finalButton) {
      const rows = [];
      if (snapshot.breed) rows.push([labels.breed,snapshot.breed]);
      if (snapshot.size) rows.push([labels.size,snapshot.size+' '+labels.inches]);
      if (snapshot.color) rows.push([labels.color,snapshot.color]);
      for (const [name,value] of fieldValues) if (value) rows.push([name.replace(/^properties\[|\]$/g,''),value]);
      if (snapshot.price) rows.push([labels.price,snapshot.price]);
      const html = '<h2>'+escapeHtml(labels.review)+'</h2><dl>'+rows.map(([name,value])=>'<dt>'+escapeHtml(name)+'</dt><dd>'+escapeHtml(value)+'</dd>').join('')+'</dl><p>'+escapeHtml(labels.shipping)+'</p><p>'+escapeHtml(labels.note)+'</p>';
      const summary = oldSummary || document.createElement('section');
      if (!oldSummary) summary.className = 'rsc-review';
      if (summary.innerHTML !== html) summary.innerHTML = html;
      const activeComponent=[...modal.querySelectorAll('.modal-ui-input-component')].find(node=>node.getClientRects().length);
      if (activeComponent && summary.parentElement!==activeComponent) activeComponent.prepend(summary);
    } else oldSummary?.remove();
    const purchase = document.querySelector('.mem_widget_ui');
    if (purchase && !purchase.querySelector('.rsc-shipping-note')) {
      const note = document.createElement('p');
      note.className = 'rsc-shipping-note';
      note.textContent = labels.shipping;
      purchase.append(note);
    }
  }
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  document.addEventListener('input',schedule,true);
  document.addEventListener('change',schedule,true);
  document.addEventListener('keydown',e=>{
    const modal = document.querySelector('.preview-modal-ui-container');
    if (!modal) return;
    if (e.key === 'Escape') { e.preventDefault(); [...modal.querySelectorAll('.preview-modal-ui-close-button, .preview-modal-ui-close-button-phone')].find(n=>n.getClientRects().length)?.click(); returnFocus?.focus(); }
    if (e.key === 'Tab') {
      const focusable = [...modal.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]')].filter(n=>n.getClientRects().length&&!n.disabled&&n.getAttribute('aria-disabled')!=='true');
      const first=focusable[0],last=focusable.at(-1);
      if (e.shiftKey && (document.activeElement===first||!modal.contains(document.activeElement))) {e.preventDefault();last?.focus();}
      else if (!e.shiftKey && (document.activeElement===last||!modal.contains(document.activeElement))) {e.preventDefault();first?.focus();}
    }
  },true);
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function(input,init) {
    let options = init;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url,location.href);
      if (url.origin===location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname) && typeof init?.body==='string') {
        const body=JSON.parse(init.body);
        if (config.productId===9562463502425 && snapshot.breed && document.querySelector('.preview-modal-ui-container')) {
          let changed=false;
          for (const item of body.items || []) {
            if (config.variantIds.some(id=>String(id)===String(item.id)) && item.properties && Object.keys(item.properties).some(k=>k.startsWith('_designData_'))) {
              item.properties={...item.properties,Breed:snapshot.breed};
              changed=true;
            }
          }
          if(changed) options={...init,body:JSON.stringify(body)};
        }
      }
    } catch {}
    return nativeFetch(input,options);
  };
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  const shippingObserver=new MutationObserver(()=>{
    const purchase=document.querySelector('.mem_widget_ui');
    if(purchase&&!purchase.querySelector('.rsc-shipping-note')) {const note=document.createElement('p');note.className='rsc-shipping-note';note.textContent=labels.shipping;purchase.append(note);}
  });
  shippingObserver.observe(document.body,{childList:true,subtree:true});
  schedule();
})();

